import { render, staticRenderFns } from "./ContactAddressDetail.vue?vue&type=template&id=11cf8b00&scoped=true&"
import script from "./ContactAddressDetail.vue?vue&type=script&lang=ts&"
export * from "./ContactAddressDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ContactAddressDetail.vue?vue&type=style&index=0&id=11cf8b00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cf8b00",
  null
  
)

export default component.exports